import { useState } from "react";
import logo from "./logo.png";
import categories from "./categories.json";
import foods from "./foods.json";

function App() {
  const [currentCategory, setCurrentCategory] = useState(1);

  return (
    <div className="container">
      <p className="restaurant-name">Nostalji Restaurant & Cafe</p>
      <div className="logo-container">
        <img className="logo" src={logo} alt="Logo" />
      </div>
      <div className="categories">
        {categories.map((category) => (
          <div
            onClick={() => setCurrentCategory(category.id)}
            key={category.id}
            className={
              currentCategory === category.id ? "category-active" : "category"
            }
          >
            {category.name}
          </div>
        ))}
      </div>
      {foods
        .filter((food) => food.categoryId === currentCategory)
        .map((food) => (
          <div key={food.id} className="food">
            <div
              style={{
                backgroundImage: `url(${food.image})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
              className="food-image"
            ></div>
            <div className="food-info">
              <div className="food-names">
                <span className="food-name">{food.name[0]}</span>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span className="food-name">{food.name[1] || ""} </span>
                  <span className="food-name">{food.name[2] || ""}</span>
                </div>
              </div>
              <p className="food-desc">{food.desc}</p>
              <span className="food-price">₺{food.price}</span>
            </div>
          </div>
        ))}
    </div>
  );
}

export default App;
